<bfx-blotter-filter-temperature
  #temperature
  *ngIf="showTemperature"
  [blotterInstance]="blotterInstance"
>
</bfx-blotter-filter-temperature>

<bfx-blotter-filter-state #stateFilter *ngIf="showStateFilter" [blotterInstance]="blotterInstance">
</bfx-blotter-filter-state>

<div *ngIf="showStateFilter || showTemperature" class="filter-bar-separator"></div>

<div class="filter-bar-item-container" #menuItemsContainer>
  <div
    *ngFor="let item of allItems"
    [ngClass]="{
      'bfx-tag-selected-md':!item.separator && item.selected, 
      'bfx-id--selected':!item.separator && item.selected, 
      'bfx-tag-unselected-md':!item.separator && !item.selected, 
      'filter-bar-item':!item.separator,    
      'filter-bar-separator': item.separator 
      }"
    title="{{item.filterName}}"
  >
    <div class="bfx-tag-toggle-button-outer" *ngIf="!item.separator">
      <button class="bfx-tag-toggle-button" (click)="selectItem(item, $event)">
        <i
          *ngIf="item.favorited"
          [ngClass]="{
        'bfx-tag-icon':true,
        'icon-ion_favorite_filled': item.favorited, 
        'filter-selected': item.selected, 
        'icon-ion_favorite': !item.favorited}"
        ></i>
        <span class="bfx-tag-label">{{item.filterName}}</span>
      </button>
    </div>
  </div>
</div>

<p-tieredMenu
  #menu
  [popup]="true"
  [model]="menuItems"
  styleClass="bfx-dashboard-menu filter-overflow-menu"
  appendTo="body"
></p-tieredMenu>
<bfx-icon-button
  [style.visibility]="overflows? 'visible':'hidden'"
  size="sm"
  iconClass="icon_ion_menu_vert"
  (action)="onClickToggle($event)"
  title="More filters..."
></bfx-icon-button>
